var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreySwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3497 15.6562L19.5535 16.2299L13.8413 3.9264C13.579 3.3609 12.9331 3.00399 12.2349 3.03821C11.5367 3.07244 10.9422 3.49127 10.7536 4.07878L8.48461 11.1762L4.57656 2.75953L5.60514 2.68783C5.98596 2.66094 6.14463 2.26166 5.83755 2.10113L1.91643 0.0477013C1.68962 -0.0712673 1.36574 0.043627 1.2976 0.266897L0.120613 4.12604C0.0282087 4.42754 0.460362 4.61822 0.755309 4.40554L1.55148 3.83188L7.25909 16.1248C7.52136 16.6903 8.16726 17.0472 8.86543 17.013C9.56359 16.9787 10.1582 16.5599 10.3467 15.9724L12.6157 8.87501L16.5285 17.3022L15.4999 17.3739C15.1191 17.4008 14.9604 17.8001 15.2675 17.9606L19.1914 20.0149C19.4182 20.1338 19.7421 20.0189 19.8102 19.7957L20.9872 15.9365C21.0796 15.635 20.6475 15.4444 20.3525 15.657L20.3497 15.6562Z",
    fill: "#757373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreySwitch);
export default __webpack_public_path__ + "static/media/greySwitch.68fb1747a3b8a3a133e64b0638bb20d1.svg";
export { ForwardRef as ReactComponent };